module.exports = __webpack_public_path__ + "img/undraw_lost.a856e094.svg";